import {
	STORE,
	BLOG,
	SHOW,
	CONTACT,
	GET_ALL,
	DELETE,
	NEWS,
	CAREER,
	APPLICATION,
	AUTH,
	REGISTER,
	LOGIN,
	PROFILE,
	TEAM_MEMBER,
	AFFILATIONS,
	HOME,
	SERVICES,
	ADDCONTENT,
	HOMEADD,
	ABOUT,
	CONTENT,
	AFFILATION,
	NEWSLETTER,
	SETTING,
	YOURIP,
	PRESIDENTS,
} from "../network/Endpoint";

import {
	doGet,
	doPost,
	doPatch,
	doDelete,
	doPostProfilePictureUpload,
} from "./Config";

export const blogstore = (data) => {
	return doPost(`${BLOG}${STORE}`, data);
};

export const blogshow = () => {
	return doGet(`${BLOG}${SHOW}`);
};

// export const blogshow = () => {
//   return doGet(`${"/teams"}`);
// };
export const affilationstore = (data) => {
	return doPost(`${AFFILATIONS}`, data);
};
export const contactstore = (data) => {
	return doPost(`${CONTACT}${STORE}`, data);
};

export const contactshow = () => {
	return doGet(`${CONTACT}${SHOW}`);
};

export const contactid = () => {
	return doGet(`${CONTACT}${GET_ALL}`);
};

export const contactdelete = () => {
	return doDelete(`${CONTACT}${DELETE}`);
};

export const newsstore = (data) => {
	return doPost(`${NEWS}${STORE}`, data);
};

export const news = () => {
	return doGet(`${NEWS}`);
};

export const newsrecord = (id) => {

	return doGet(`${NEWS}${SHOW}${id}`);
};

export const newsdelete = () => {
	return doDelete(`${NEWS}${DELETE}`);
};

export const careerstore = (data, token) => {
	return doPost(`${CAREER}${STORE}`, data, token);
};

export const careerget = () => {
	return doGet(`${CAREER}`);
};

export const careershow = () => {
	return doGet(`${CAREER}${SHOW}`);
};

export const careerdelete = () => {
	return doGet(`${CAREER}${DELETE}`);
};
export const applicationstore = (data) => {
	return doPost(`${APPLICATION}${STORE}`, data);
};

export const PostTeams = () => {
	return doPostProfilePictureUpload(`${TEAM_MEMBER}${STORE}`);
};

export const homecontent = () => {
	return doGet(`${HOME}`);
};

export const contentpost = (data) => {
	return doPostProfilePictureUpload(`${HOME}`,data);
};

export const homeaddpost = (data) => {
	return doPostProfilePictureUpload(`${HOMEADD}`,data);
};

export const servicesadd = (data) => {
	return doPostProfilePictureUpload(`${SERVICES}${ADDCONTENT}`,data);
};

export const servicesgetbyslug = (data) => {
	return doGet(`${SERVICES}${"/get-content"}${data?.slug}`);
};

export const aboutget = () => {
	return doGet(`${ABOUT}${CONTENT}`);
};

export const affilationget = () => {
	return doGet(`${AFFILATION}${CONTENT}`);
};

export const affilationpost = (data) => {
	return doPostProfilePictureUpload(`${AFFILATION}${CONTENT}`,data);
};

export const newsletterget = () => {
	return doGet(`${NEWSLETTER}`);
};

export const newspostapi = (data) => {
	return doPost(`${NEWSLETTER}${STORE}`, data);
};

export const settingget = () => {
	return doGet(`${SETTING}${CONTENT}`);
};

export const yourippost = (data) => {
	return doPostProfilePictureUpload(`${YOURIP}${STORE}`, data);
};

export const presidentget = () => {
	return doGet(`${PRESIDENTS}${CONTENT}`);
};

export const careerrecord = (id) => {

	return doGet(`${CAREER}${SHOW}/${id}`);
};

export const teamsrecord = (id) => {

	return doGet(`${TEAM_MEMBER}${SHOW}/${id}`);
};

